// extracted by mini-css-extract-plugin
module.exports = {"customStyles":"Parent_customStyles__15BDi"};